import React, { useEffect } from "react";
import { Drawer, Form, Input, Button, Switch, Select } from "antd";

const CreateTable = ({ open, onClose, onSubmit, initialValues, form, zone }) => {
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        status: initialValues.status === "occupied",
        is_active: Number(initialValues.is_active) === 1,
        ac_type: initialValues.ac_type || "NON_AC",
      });
    } else {
      form.resetFields();
      form.setFieldsValue({
        status: false,
        is_active: true,
        ac_type: "NON_AC",
      });
    }
  }, [initialValues, form]);

  const handleFinish = (values) => {
    const formattedValues = {
      ...values,
      status: values.status ? "occupied" : "available",
      is_active: values.is_active ? 1 : 0,
      ac_type: values.ac_type || "NON_AC",
    };

    onSubmit(formattedValues);
  };

  return (
    <Drawer
      title={initialValues ? "Edit Table" : "Create Table"}
      width={900}
      open={open}
      onClose={onClose}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <div className="page-card table-card">
          <div className="table-card-header">
            <div>
              <h3>{initialValues ? "Update Table Details" : "Create Table Details"}</h3>
              <p>Fill the details below to save the table.</p>
            </div>
          </div>

          <Form.Item
            label="Table Name"
            name="name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <div className="form-grid-2">
            <Form.Item
              label="Capacity"
              name="capacity"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Zone"
              name="zone_id"
              rules={[{ required: true, message: "Please select zone" }]}
            >
              <Select
                className="page-select"
                options={zone.map((r) => ({
                  label: r.name,
                  value: r.id,
                }))}
              />
            </Form.Item>

            <Form.Item
              label="AC Type"
              name="ac_type"
              rules={[{ required: true, message: "Please select AC type" }]}
            >
              <Select
                className="page-select"
                options={[
                  { label: "AC", value: "AC" },
                  { label: "Non AC", value: "NON_AC" },
                ]}
              />
            </Form.Item>
          </div>

          <div className="form-grid-2">
            <Form.Item
              label="Occupied"
              name="status"
              valuePropName="checked"
            >
              <Switch checkedChildren="Occupied" unCheckedChildren="Available" />
            </Form.Item>

            <Form.Item
              label="Active"
              name="is_active"
              valuePropName="checked"
            >
              <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
            </Form.Item>
          </div>

          <div className="form-actions">
            <Button className="secondary-btn" onClick={onClose}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" className="primary-btn">
              Save
            </Button>
          </div>
        </div>
      </Form>
    </Drawer>
  );
};

export default CreateTable;